export var InvestorCommunicationsType;
(function (InvestorCommunicationsType) {
    InvestorCommunicationsType["TaxCertificates"] = "tax-certificates";
    InvestorCommunicationsType["TaxReports"] = "tax-reports";
    InvestorCommunicationsType["InvestorReports"] = "investor-reports";
    InvestorCommunicationsType["ExitStatements"] = "exit-statements";
    InvestorCommunicationsType["CustomUpdates"] = "custom-updates";
    InvestorCommunicationsType["DeploymentUpdates"] = "deployment-updates";
})(InvestorCommunicationsType || (InvestorCommunicationsType = {}));
//# sourceMappingURL=api.js.map